export class Shift {
	public id: string = '';
	public user?: string;
	public project: string;
	public startTime: Date;
	public endTime: Date;
	public parent?: string;
	public wasOrphaned?: boolean;
	public rateOverride?: number;
	public isPublished?: boolean;
	public acceptedAt?: Date;
	public rejectedAt?: Date;
	public breakMinutes?: number;
	public notes?: string;
	public isHoliday?: boolean;
	public workerApproved?: boolean;
	public adminApproved?: boolean;
	public employee?: any;
	public isParent: boolean;
	public requiresApproval?: boolean;
	public worked?: boolean;
	public actualStartTime?: actualStartEndTime[];
	public actualEndTime?: actualStartEndTime[];
	public hoursApproved?: 'scheduled' | 'actual'; // actualStartTime and actualEndTime are locked once this field exists
	public workedApproved?: {
		user: string;
		date: Date;
	};
	public normalHours?: number;
	public overtimeHours?: number;
	public actualLabourCost?: number;
	public updateRepeatedShifts?: boolean;

	constructor(obj?: Partial<Shift>) {
		if (obj) {
			Object.assign(this, JSON.parse(JSON.stringify(obj)));
		}
	}
}

export interface ShiftResponse {
	shifts: Shift[];
	status: boolean;
}

export class ShiftSaveObj {
	public id?: string;
	public user?: string;
	public project: string;
	public startTime: Date;
	public endTime: Date;
	public parent?: string;
	public isParent: boolean;
	public wasOrphaned?: boolean;
	public rateOverride?: number;
	public breakMinutes?: number;
	public notes?: string;
	public isHoliday?: boolean;
	public isPublished?: boolean;
	public requiresApproval?: boolean;
	public actualStartTime?: actualStartEndTime[];
	public actualEndTime?: actualStartEndTime[];
	public hoursApproved?: 'scheduled' | 'actual'; // actualStartTime and actualEndTime are locked once this field exists
	public workedApproved?: {
		user: string;
		date: Date;
	};
	public normalHours?: number;
	public overtimeHours?: number;
	public actualLabourCost?: number;
	public updateRepeatedShifts?: boolean;
}

export type actualStartEndTime = {
	date: Date;
	location?: {
		type: string;
		coordinates: [number, number];
	};
	editedBy: string;
	editedDate: Date;
};
